<div class="dialog-box">
  <div class="create-logo" [ngClass]="page === 'google' ? 'google-logo' : page === 'youtube' ? 'youtube-logo' : page === 'tiktok' ? 'tiktok-logo' : 'microsoft-logo'">
  </div>
  <div class="middle-text">
    <span>
      Create a new <b>{{ platformLabel }} Ads</b> account through our Media Blast app and unlock {{ couponAmount }} for eligible accounts!
    </span>
  </div>
  <div class="mb-btn">
    <p-button  label="Continue to Media Blast" styleClass="primary-btn select-coupon" (onClick)="goToMediaBlast()"></p-button>
  </div>
</div>
